'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hostGetter;
function hostGetter() {
  return location.host;
}


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.services/host.getter.js
// module id = 133
// module chunks = 2